module.exports = __webpack_public_path__ + "static/img/title-ar.a7cc815b.webp";